import { t } from '@/i18n'

export function flatNumberFormat(val) {
  return val
  /*
  if (val === null || val === undefined || val.value === '') return ' '
  let million = false
  let thousand = false
  let parseVal = 0
  if (val / 1000000 >= 1) {
    parseVal = (val / 1000000).toFixed(1)
    million = true
  } else if (val / 100000 >= 1) {
    parseVal = (val / 1000).toFixed(1)
    thousand = true
  } else parseVal = val
  parseVal = parseVal
    .toString()
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  if (million) parseVal = parseVal + 'm'
  else if (thousand) parseVal = parseVal + 'k'
  return parseVal
  */
}

//  any	2007-01-01T00:00:00Z	2007-12-31T23:59:59Z	2007	vd0drezshs
//  mes	2009-09-01T00:00:00Z	2009-09-30T00:00:00Z	Set 2009	DNB_S6.8
//  curs	2004-09-01T00:00:00Z	2005-06-30T23:59:59Z	Curs 2015-16	z6ruj5tvpu
//  trimestre	1997-04-01T00:00:00Z	1997-06-30T23:59:59Z	1r tr 2007	zolxfo8phi
//  periode	1900-01-01T00:00:00Z	1901-12-31T23:59:59Z	10/10/2019 – 10/11/2019	g34nrhmtav
//  semestre	2000-01-01T00:00:00Z	2000-06-30T23:59:59Z	1r sem 2007	cjtwk4hdxc
// bimestre	2004-07-01T00:00:00Z	2004-08-31T23:59:59Z	Gen-Feb 2010	fmh4rbp8p3
import dayjs from 'dayjs'
var isoWeek = require('dayjs/plugin/isoWeek')

dayjs.extend(isoWeek)

export function formatId(datum, dimension) {
  if (dimension.type === 'time') {
    let { start, end } = datum
    if (datum.type.toLowerCase() === 'any') {
      return dayjs(start).format('YYYY')
    } else if (datum.type.toLowerCase() === 'mes') {
      return `${dayjs(start).format('MMM')} ${dayjs(start).format('YYYY')}`
    } else if (datum.type.toLowerCase() === 'dia') {
      return `${dayjs(start).format('DD MMM')} ${dayjs(start).format('YYYY')}`
    } else if (datum.type.toLowerCase() === 'setmana') {
      //week number -> ${dayjs(start).format('W')}
      return `${t('week')} ${dayjs(start).format('DD-MM-YYYY')}`
    } else if (datum.type.toLowerCase() === 'curs') {
      return `Curs ${dayjs(start).format('YYYY')}-${dayjs(end).format('YY')}`
    } else if (datum.type.toLowerCase() === 'trimestre') {
      return getTrimestre(datum)
    } else if (datum.type.toLowerCase() === 'període') {
      return `${dayjs(start).format('DD-MM-YYYY')} - ${dayjs(end).format('DD-MM-YYYY')}`
    } else if (datum.type.toLowerCase() === 'semestre') {
      return getSemestre(datum)
    } else if (datum.type.toLowerCase() === 'bimestre') {
      return `${dayjs(start).format('MMM')}-${dayjs(end).format('MMM')} ${dayjs(start).format(
        'YYYY'
      )}`
    }
  } else {
    return datum.label || datum
  }
}

function getTrimestre(datum) {
  let date = dayjs(datum.start)
  let m = date.month()
  let y = date.year()
  if (m < 3) return `${t('first_trim')} ${y}`
  else if (m < 6) return `${t('second_trim')} ${y}`
  else if (m < 9) return `${t('third_trim')} ${y}`
  else return `${t('fourth_trim')} ${y}`
}

function getSemestre(datum) {
  let date = dayjs(datum.start)
  let m = date.month()
  let y = date.year()
  if (m < 6) return `${t('first_sem')} ${y}`
  else return `${t('second_sem')} ${y}`
}

import { isNombre } from '@/utils/chart'
const numeral = require('numeral')


export function maskValue(value, dataCard, secret) {
  if (secret) return '..'
  if (value === null || value === undefined) return '-'
  if (isNaN(Number(value))) return value
  let mask = dataCard?.mask || (isNombre(dataCard?.data[0].unit) ? '0,0' : '0,0.0')
  let percentSign = ''
  if (mask && mask.charAt(mask.length - 1) === '%') {
    mask = mask.slice(0, mask.length - 1)
    percentSign = '%'
    if (mask.charAt(mask.length - 1) === ' ') mask = mask.slice(0, mask.length - 1)
  }
  return numeral(+value).format(mask) + percentSign
}
